module.exports = __webpack_public_path__ + "img/contact_popup.e4f2ea19.svg";